import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  routes:[{
    path: '/',
    redirect: `/login`,
    component: () => import ('views/login/login.vue'),
  },
  {
    path: '/login/:type?',
    name: 'login',
    component: () => import('views/login/login.vue'),
  }
],
  scrollBehavior(to, from, savedPosition) {
    if (document.getElementById("con"))
      document.getElementById("con").scrollTop = 0;
  }
})
